import { BaseModel, apolloMutation, MutationResult } from 'vue-apollo-model';
import gql from 'graphql-tag';
import { Mutation } from '@/generated-models';
import { RouteName } from '@/router';

export default class FollowModel extends BaseModel {
    @apolloMutation<FollowModel>({
        mutation: gql`
            mutation visionFollow($touid: String, $ftype: Int, $followSource: Int, $expTag: String) {
                visionFollow(touid: $touid, ftype: $ftype, followSource: $followSource, expTag: $expTag) {
                    result
                    followStatus
                    hostName
                    error_msg
                }
            }
        `,
        variables({ touid, ftype, expTag }) {
            let followSource = 0;
            switch (this.$route.name) {
                case RouteName.Profile:
                    followSource = 1;
                    break;
                case RouteName.Search:
                    followSource = 2;
                    break;
                case RouteName.ShortVideo:
                case RouteName.Video:
                    followSource = 3;
                    break;
            }
            return {
                touid,
                ftype,
                followSource,
                expTag,
            };
        },
    })
    private followMutation!: MutationResult<
        { touid: string; ftype: number; expTag: string },
        {
            visionFollow: Mutation['visionFollow'];
        }
    >;

    async follow(userId: string, follow: boolean, expTag: string) {
        const ftype = follow ? 2 : 1;
        await this.followMutation.mutate({
            touid: userId,
            ftype,
            expTag,
        });
    }

    get followStatus() {
        return this.followMutation.data.visionFollow?.followStatus;
    }
    get result() {
        return this.followMutation.data.visionFollow?.result;
    }

    get errMsg() {
        return (
            this.followMutation.data.visionFollow?.error_msg
            || '网络异常,请稍后重试'
        );
    }
}
